import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	resetViewSettingsButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveOrResetViewSettingsButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveViewSettingsMenuItem: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resetViewSettingsMenuItem: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveSettingsSuccessTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveSettingsSuccessMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveSettingsFailedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveSettingsFailedMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resetSettingsFailedTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	resetSettingsFailedMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveConfirmationModalTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveConfirmationModalBody: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	saveSettingsSuccessMessageGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	resetViewSettingsButton: {
		id: 'issue-navigator-save-reset-view-settings-button.reset-view-settings-button',
		defaultMessage: 'Reset list back to default',
		description:
			'Label for the button to allow users to reset changes made to the list view settings',
	},
	saveOrResetViewSettingsButton: {
		id: 'issue-navigator-save-reset-view-settings-button.save-or-reset-view-settings-button',
		defaultMessage: 'Save or reset view settings',
		description:
			'Label for the menu trigger button to allow users to save or reset changes made to the view settings',
	},
	saveViewSettingsMenuItem: {
		id: 'issue-navigator-save-reset-view-settings-button.save-view-settings-menu-item',
		defaultMessage: 'Save list',
		description:
			'Label for the menu item to allow users to save changes made to the list view settings',
	},
	resetViewSettingsMenuItem: {
		id: 'issue-navigator-save-reset-view-settings-button.reset-view-settings-menu-item',
		defaultMessage: 'Reset to last saved',
		description:
			'Label for the menu item to allow users to reset changes made to the view settings',
	},
	saveSettingsSuccessTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.save-settings-success-title',
		defaultMessage: 'List view saved',
		description: 'Success title informing the user saving list view settings succeeded.',
	},
	saveSettingsSuccessMessage: {
		id: 'issue-navigator-save-reset-view-settings-button.save-settings-success-message',
		defaultMessage: 'This view has been updated for everyone in this project.',
		description: 'Success message informing the user saving list settings succeeded.',
	},
	saveSettingsFailedTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.save-settings-failed-title',
		defaultMessage: 'Unable to save your settings',
		description: 'Error title informing the user saving view list settings failed.',
	},
	saveSettingsFailedMessage: {
		id: 'issue-navigator-save-reset-view-settings-button.save-settings-failed-message',
		defaultMessage: "We couldn't save your settings, try refreshing the page or try again later.",
		description: 'Error message informing the user saving list settings failed.',
	},
	resetSettingsFailedTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.reset-settings-failed-title',
		defaultMessage: 'Unable to reset your settings',
		description: 'Error title informing the user resetting list settings failed.',
	},
	resetSettingsFailedMessage: {
		id: 'issue-navigator-save-reset-view-settings-button.reset-settings-failed-message',
		defaultMessage: "We couldn't reset your settings, try refreshing the page or try again later.",
		description: 'Error message informing the user resetting view settings failed.',
	},
	saveConfirmationModalTitle: {
		id: 'issue-navigator-save-reset-view-settings-button.save-confirmation-modal-title',
		defaultMessage: 'Save list view',
		description: 'Title for the modal to confirm saving the list view settings',
	},
	saveConfirmationModalBody: {
		id: 'issue-navigator-save-reset-view-settings-button.save-confirmation-modal-body',
		defaultMessage:
			"The list will be saved for everyone in the project. They'll see the applied filters, grouping, fields, and columns.",
		description: 'Description for the modal to confirm saving the list view settings',
	},
	saveButton: {
		id: 'issue-navigator-save-reset-view-settings-button.save-button',
		defaultMessage: 'Save',
		description: 'Label for the button to confirm saving the list view settings',
	},
	cancelButton: {
		id: 'issue-navigator-save-reset-view-settings-button.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Label for the button to cancel saving the list view settings',
	},
	saveSettingsSuccessMessageGalaxia: {
		id: 'issue-navigator-save-reset-view-settings-button.save-settings-success-message-galaxia',
		defaultMessage: 'This view has been updated for everyone in this space.',
		description: 'Success message informing the user saving list settings succeeded.',
	},
});
export default messages;
